import * as t from 'io-ts';
import { SavedAudienceStandardTargetingSpec } from '../../facebook/audience/SavedAudience';
import { MatchKeys } from '../../offline-events/MatchKeys';

/**
 * Example Usage:
 *   const csvData = CustomerFileCSVData.decode(exampleCustomerFileCSVData)
 *   if (csvData._tag === 'Left') throw Error(csvData.left.join(', '))
 *   const {headers, data} = csvData.right
 */
export const CustomerFileCSVData = t.type({
  headers: t.array(t.keyof(MatchKeys)),
  data: t.array(t.array(t.string)),
});

export type CustomerFileCSVData = t.TypeOf<typeof CustomerFileCSVData>;

export const exampleCustomerFileCSVData: CustomerFileCSVData = {
  headers: ['fn', 'ln', 'email', 'phone'],
  data: [
    ['John', 'Doe', 'john@example.com', '123-456-7890'],
    ['Jane', 'Doe', 'jane@example.com', '123-456-7890'],
  ],
};

export const CustomerFileAudienceDTO = t.intersection([
  t.type({
    name: t.string,
    isDefault: t.boolean,
    // TODO: io-ts'ify the targetingSpec
    targetingSpec: t.UnknownRecord,
    csvData: CustomerFileCSVData,
  }),
  t.partial({
    description: t.string,
  }),
]);

type CustomerFileAudienceDTOWithWrongTargetingSpec = t.TypeOf<
  typeof CustomerFileAudienceDTO
>;
export type CustomerFileAudienceDTO = Omit<
  CustomerFileAudienceDTOWithWrongTargetingSpec,
  'targetingSpec'
> & {
  targetingSpec: SavedAudienceStandardTargetingSpec;
};

export type CustomerFileValidationError = {
  field: MatchKeys;
  row: number;
  errorMessage: string;
};

export const exampleCustomerFileValidationError = {
  field: 'fn',
  row: 0,
  errorMessage:
    "The name 'Jerry' is not allowed. Please pick a different name.",
};
